import { Button } from "../../IO";
import { Scale, CreateElement, SetStyles } from "../../MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { TranslatorView } from "../../TranslatorView";
import { ZIndex } from "../../ZIndex";
import { PanelParams } from "./IPanelFactory";
import { ButtonState, Panel } from "./panel";
import {TweenLite} from "gsap";
import { Settings } from "../../Settings";
import { roundToNearestMinutes } from "date-fns";
import { Transform } from "pixi.js";
import { IInterval } from "../../Context/Interval";
import { readable } from "svelte/store";
import { service } from "../../services";

export class PanelOnline extends Panel
{
    private languageView:TranslatorView = null;//asodfhagiuyasasdfkljh
    protected gamePath: string = "";
    protected spinArrow: ImageResource = null;// New Element
    protected spinArrowDiv: HTMLElement;//New Element
    protected spinCircleSmallArrowDiv: HTMLElement;//New Element

	public constructor(params: PanelParams)
	{
		super(params);

		this.backendSettings = params.backendSettings;
		this.resid = params.resid.Add("Panel-Online");
		this.resourcesBasePath = params.resourcesBasePath;
        this.audio = params.audio;
		this.translator = params.translator;

		this.systemContext = params.systemContext.CreateSubContext("Panel");

		this.idleAnim = this.systemContext.TimingContext().CreateInterval("idleAnim", 500, () => this.IdleAnim())
		this.languageView = new TranslatorView(this.resid);
        this.gamePath = Settings.ResourcesFolder + "multigame/slot/common/resources/";//New Element
    }
    
 

	public override SetMessage(message: string): void {
        //this.view.querySelector(".message").innerHTML = message;
        this.messageElem.textContent = message;
	}


    protected buttonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.XYpx(4)} solid gold`,
    };

    protected autoplayButtonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.XYpx(4)} solid red`,
    };


	public override ConstructHtml()
    {

        let cssLinear: Partial<CSSStyleDeclaration> = {
            borderWidth: Scale.XYpx(5),
            borderStyle: "solid",
            position: "relative",
            margin: "0px auto",
            bottom: Scale.Ypx(5),
            filter: `blur(${Scale.XYpx(2)})`,
            width: "80%",
            borderImage: this.ButtonBackground().linearColor
        };

        let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "column",
            //justifyContent: "flex-end",
        };

        let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "row",
            flexGrow: "1",
        };

        let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(100),
            width: Scale.Wpx(70),
		};
		
		let cssMenuInfoButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(40),
            width: Scale.Wpx(70),
        };

        let cssButton: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),
    
            border: `${Scale.XYpx(4)} solid gold`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",
        
            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),
        
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
        
            //backgroundOrigin: "border-box",
            //backgroundClip: "content-box, border-box",
            background: "rgba(0, 0, 0,0.5)",
        };

        let cssLabel: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(20),
            lineHeight: "0px",
            //color: "white",
            textAlign: "center",
        
            fontFamily: "NotoSansDisplay-Bold",
            fontWeight: "bold", 
            color: "white",
            textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        };
    
        let cssMessageValue: Partial<CSSStyleDeclaration> = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: Scale.fhpx(20),
        
            color: "white",
            textShadow: "0 0 10px black",
            background: "transparent",
        };
        //credits
        let cssCredit: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(35),
            lineHeight: Scale.Hpx(40),
            textAlign: "center",
            height: "100%",
        
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        
            color: "white",
            top: Scale.Ypx(25),
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            
        };
        //money
        let cssCurrency: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(20),
            textAlign: "center",
            color: "yellow",
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(14),
            left: Scale.Ypx(0),
            margin: Scale.Ypx(0),

        }

        // /* #region Left column */
        // let leftCol = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-group-value-collect"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup
        //     }
        // });

        //     this.butVolume = CreateElement("div", {
        //         classes: ["but-vol", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
		// 			...cssButton,
		// 			//borderRadius: Scale.XYpx(50),
    
        //         }
        //     });

        //         let butVolLabel = CreateElement("div", {
        //             classes: ["but-vol-value", "label"],
        //             parentToAppend: this.butVolume,
        //             style: {
        //                 ...cssLabel
        //             }
        //         });
        
        //     this.butDenom = CreateElement("div", {
        //         classes: ["but-denom", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
        //             ...cssButton
        //         }
        //     });

        //         this.denomElem = CreateElement("div", {
        //             classes: ["denom-value", "message-value"],
        //             parentToAppend: this.butDenom,
        //             style: {
        //                 ...cssMessageValue
        //             }
        //         });

        //             let butDenomDenom = CreateElement("div", {
        //                 classes: ["denom-denom"],
        //                 parentToAppend: this.denomElem
        //             });


        /* #endregion */

        //this.view.innerHTML += 
        // `
        // <!-- new panel -->
        // <div class="but-vertical-group but-group-value-collect">
        //     <div class="but-vol button">
        //         <span class="but-vol-value label">
        //         </span>
        //     </div>
        
        //     <!--
        //     <div class="but-collect button">
        //         <span class="but-collect-value label">COLLECT</span>
        //     </div>
        //     -->
        //     <div class="but-denom button">
        //         <div class="denom-value message-value"><span class="denom-denom"></span></div>
        //     </div>
        // </div>`
        
        
        // `<div class="but-horizontal-group but-left-group">
        //     <div class="but-vertical-group but-group-denom-balance">
        
        
        //         <div class="but-credit button">
        //             <div class="but-credit-label label">
        
        //             </div>
        //             <div class="but-credit-currency currency">
        //                 <span class="but-credit-currency-value">123,456.00</span>
        //                 <!--<span class="but-credit-currncy-icon"></span>-->
        //             </div>
        //             <div class="but-credit-credit credit">123456</div>
        
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        
        //     <div class="but-vertical-group but-group-lines-totalbet">
        //         <div class="but-lines button " style="border: hidden; box-shadow: none;">
        //             <div class="but-lines-value message-value"><span class="playinon"> </span>&nbsp;<span
        //                     class="selected-lines"></span>&nbsp;
        //                 <span class="lines"></span></div>
        //         </div>
        
        //         <div class="but-horizontal-group">
        
        //             <div class="but-totalbet button">
        
        //                 <div class="but-totalbet-label label"></div>
        //                 <div class="but-totalbet-currency currency">
        //                     <span class="but-totalbet-currency-value">123.00</span>
        //                     <!--<span class="but-totalbet-currency-symbol"></span>-->
        //                 </div>
        
        //                 <div class="but-totalbet-credit credit">123</div>
        //                 <div class="linear"> </div>
        
        //             </div>
        
        //             <div class="but-betperline button" style="visibility: hidden;">
        //                 <div class="but-betperline-label label"></div>
        //                 <div class="but-betperline-credit credit">123</div>
        //                 <div class="but-betperline-currency currency">
        //                     <span class="but-betperline-currency-value">123.00</span>
        //                     <!--<span class="but-betperline-currency-symbol"></span>-->
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        
        
        // </div>`;

        // LEFT GROUP
        let grpLeft = CreateElement("div", {classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
            ...cssVerticalGroup,
            width: "100%"
        }});
            let btnLines = CreateElement("div", {classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
                height: Scale.Hpx(35),
                //position: "relative",
                //left: "-224px",
                //background: "transparent",
                //...cssButton
                alignSelf: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }});

                this.linesDenomMessage = this.translator.Translate(() => this.translator.t.playingDenomOnLines(service.moneyFormatter.FormatCurrency(1), this.lines));
                let btnLinesValue = CreateElement("div", {
                    classes: ["but-lines-value", "message-value"], 
                    parentToAppend: btnLines, 
                    childToAppend: this.linesDenomMessage.location,
                    style: {
                        ...cssMessageValue
                    }
                });

            let grpDenomBalance = CreateElement("div", {classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
                ...cssHorizontalGroup, 
                //flexGrow: "1"
                justifyContent: "space-evenly",
            }});
                this.btnBalance = CreateElement("div", {classes:["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
                    position: "relative",
                    alignSelf: "flex-end",
                    //left: "80px",
                    width: Scale.Wpx(220),
                    ...cssButton
                }});
                    let btnBalanceLabel = CreateElement("div", {
                        classes: ["but-credit-label", "label"], 
                        parentToAppend: this.btnBalance, 
                        childToAppend: this.translator.Anchor(() => this.translator.t.balance),
                        style: {
                            ...cssLabel
                        }
                    });

                    this.balanceCurrency = CreateElement("div", {classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
                        ...cssCurrency
                    }});
                        let btnBalanceCurrencyValue = CreateElement("span", {classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00"});
                    this.balanceCredits = CreateElement("div", {classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
                        ...cssCredit
                    }});
                    let btnBalanceLinear = CreateElement("div", {classes: ["linear"], parentToAppend: this.btnBalance, style: {
                        ...cssLinear
                    }});

            // let grpLinesTotalbet = CreateElement("div", {classes: ["but-vertical-group", "but-group-lines-totalbet"], parentToAppend: grpLeft, style: {
            //     ...cssVerticalGroup,
            //     justifyContent: "space-evenly"
            // }});

                        // TODO some spans, not needed 
                // let grpTotalPerLine = CreateElement("div", {classes: ["but-horizontal-group"], parentToAppend: grpDenomBalance, style: {
                //     ...cssHorizontalGroup
                // }});

                {
                    let butDenom = CreateElement("div", {classes: ["but-denom", "button"], parentToAppend: grpDenomBalance, style: {
                        //alignSelf: "flex-end",
                        //flexGrow: "1",
                        alignSelf: "flex-end",
                        position: "relative",
                        //left: "127px",
                        width: Scale.Wpx(122),
                        ...cssButton
                    }});
                    this.butDenom = butDenom;
                        let butDenomLabel = CreateElement("div", {
                            classes: ["but-denom-label", "label"], 
                            parentToAppend: butDenom, 
                            childToAppend: this.translator.Anchor(() => this.translator.t.denom),
                            style: {
                                ...cssLabel
                            }
                        });
                        this.totalBetCurrency = CreateElement("div", {classes: ["but-denom-currency", "currency"], parentToAppend: butDenom, childToAppend: this.translator.Anchor(() => this.translator.t.denomOneCredit), style: {
                            ...cssCurrency
                        }});
                            // TODO span
                        this.denomElem = CreateElement("div", {classes: ["but-denom-credit", "credit"], parentToAppend: butDenom, innerHTML: "123", style: {
                            ...cssCredit
                        }});
                        let butDenomLinear = CreateElement("div", {classes: ["linear"], parentToAppend: butDenom, style: {
                            ...cssLinear
                        }});
                    }


                    {
                        let btnTotalbet = CreateElement("div", {classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
                            //alignSelf: "flex-end",
                            //flexGrow: "1",
                            alignSelf: "flex-end",
                            position: "relative",
                            //left: "127px",
                            width: Scale.Wpx(122),
                            ...cssButton
                        }});
                        this.butTotalBet = btnTotalbet;
                            let btnTotalbetLabel = CreateElement("div", {
                                classes: ["but-totalbet-label", "label"], 
                                parentToAppend: btnTotalbet, 
                                childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
                                style: {
                                    ...cssLabel
                                }
                            });
                            this.totalBetCurrency = CreateElement("div", {classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
                                ...cssCurrency
                            }});
                                // TODO span
                            this.totalBetCredits = CreateElement("div", {classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
                                ...cssCredit
                            }});
                            let btnTotalbetLinear = CreateElement("div", {classes: ["linear"], parentToAppend: btnTotalbet, style: {
                                ...cssLinear
                            }});

                        let btnPerLine = CreateElement("div", {
                            classes: ["but-betperline", "button"], 
                            parentToAppend: grpDenomBalance, 
                            style: {
                                alignSelf: "flex-end",
                                flexGrow: "1",
                                ...cssButton,
                                display: "none",
                            }
                        });
                            let btnPerLineLabel = CreateElement("div", {
                                classes: ["but-betperline-label", "label"], 
                                parentToAppend: btnPerLine, 
                                childToAppend: this.translator.Anchor(() => this.translator.t.tline),
                                style: {
                                    ...cssLabel
                                }
                            });
                            this.betCredits = CreateElement("div", {
                                classes: ["but-betperline-credit", "credit"], 
                                parentToAppend: btnPerLine, 
                                innerHTML: "123", 
                                style: {
                                    ...cssCredit
                                }
                            });
                            this.betCurrency = CreateElement("div", {
                                classes: ["but-betperline-currency", "currency"], 
                                parentToAppend: btnPerLine, 
                                style: {
                                    ...cssCurrency
                                }
                            });
                            // TODO span
                    }

        //this.butTotalBet = this.view.querySelector(".but-totalbet");
         
        // this.view.innerHTML += `<div class="but-vertical-group">
        
        //     <div class="but-win button">
        //         <div class="but-win-label label"></div>
        //         <div class="but-win-currency currency">
        //             <span class="but-win-currency-value">123,456.00</span>
        //             <!--<span class="but-win-currncy-icon">MXN</span>-->
        //         </div>
        //         <div class="but-win-credit credit">999999</div>
        //         <div class="linear"></div>
        //     </div>
        // </div>`;

        

        let centerCol = CreateElement("div", {
            classes: ["but-vertical-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup
            }
        });

            let butWin = CreateElement("div", {
                classes: ["but-win", "button"],
                parentToAppend: centerCol,
                style: {
                    position: "relative",
                    ...cssButton,
                    width: Scale.Wpx(480),
                    flexGrow: "1",
                }
            });

                let butWinLabel = CreateElement("div", {
                    classes: ["but-win-label", "label"],
                    parentToAppend: butWin,
                    style: {
                        fontSize: Scale.fhpx(30),
                        lineHeight: "0px",
                        ...cssLabel
                    }
                });

                this.winCurrency = CreateElement("div", {
                    classes: ["but-win-currency", "currency"],
                    parentToAppend: butWin,
                    style: {
                        fontSize: Scale.fhpx(35),
                        textAlign: "center",
                        color: "yellow",
                        textShadow: "0 0 10px black",
                        position: "relative",
                        top: Scale.Ypx(30),
                    }
                });

                    // let butWinCurrencyValue = CreateElement("span", {
                    //     classes: ["but-win-currency-value"],
                    //     parentToAppend: butWinCurrency
                    // });

                this.winCredits = CreateElement("div", {
                    classes: ["but-win-credit", "credit"],
                    parentToAppend: butWin,
                    style: {
                        ...cssCredit,
                        fontSize: Scale.fhpx(65),
                        lineHeight: Scale.Hpx(100), 
                        marginTop: Scale.Ypx(2),
                    }
                });

                let butWinLinear = CreateElement("div", {
                    classes: ["linear"],
                    parentToAppend: butWin,
                    style: {
                        ...cssLinear,
                        bottom: Scale.Ypx(14),
                        
                    }
                });


        
        // this.view.innerHTML += `
        // <div class="but-vertical-group but-group-autplay-maxbet-spin-messages but-right-group">
        //     <div class="but-message button message-value message" style="border: hidden; box-shadow: none;">
        //     </div>
        
        //     <div class="but-horizontal-group but-group-autoplay-maxbet-spin">
        //         <div class="but-horizontal-group but-group-autoplay-maxbet">
        //             <div class="but-auto-play button" style="visibility: hidden;">
        //                 <div class="but-auto-play-label label"></div>
        //             </div>
        
        //             <div class="but-max-bet button" style="position: relative; left: -100px;">
        //                 <div class="but-max-bet-label label"></div>
        //                 <div class="linear"> </div>
        //             </div>
        //         </div>
        
        
        //         <div class="but-spin button ">
        //             <div id="spindix" class="but-spin-label label"></div>
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        // </div>`;

        let grpRight = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-autplay-maxbet-spin-messages", "but-right-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
                width: "100%",
            }
        });

        this.messageElem = CreateElement("div", {
                classes: ["but-message", "button", "message-value", "message"],
                parentToAppend: grpRight,
                style: {
                    height: Scale.Hpx(35),
                    position: "relative",
                    //left: "-30px",
                    //...cssButton,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: Scale.fhpx(20),
                    color: "white",
                    textShadow: `0 0 ${Scale.XYpx(10)} black`,
                    background: "transparent",
                }
            });

            let grpRightHorizontal = CreateElement("div", {
                classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
                parentToAppend: grpRight,
                style: {
                    ...cssHorizontalGroup,
                    flexGrow: "1",
                    justifyContent: "space-evenly",
                }
            });

                let grpAutoplayMaxbet = CreateElement("div", {
                    classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
                    parentToAppend: grpRightHorizontal,
                    style: {
                        ...cssHorizontalGroup,
                        flexGrow: "0",
                    }
                });

                // this.butAutoplay = CreateElement("div", 
                //     {
                //         classes: ["but-auto-play", "button"],
                //         parentToAppend: grpAutoplayMaxbet,
                //         style: {
                //             //flexGrow: "1",
                //             alignSelf: "flex-end",
                //             ...cssButton,
                //             //display: "none",
                //         }
                //     });

                // let butAutplayLabel = CreateElement("div", 
                //         {
                //             classes: ["but-auto-play-label", "label"],
                //             parentToAppend: this.butAutoplay,
                //             childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                //             style: {
                //                 ...cssLabel,
                //                 fontSize: Scale.fhpx(18),
                                
                //             }
                //         });

                    this.butMaxBet = CreateElement("div", {
                        classes: ["but-max-bet", "button"],
                        parentToAppend: grpAutoplayMaxbet,
                        style: {
                            //flexGrow: "1",
                            alignSelf: "flex-end",
                            ...cssButton,
                            width: Scale.Wpx(120),
                        }
                    })

                        let butMaxBetLabel = CreateElement("div", {
                            classes: ["but-max-bet-label", "label"],
                            parentToAppend: this.butMaxBet,
                            childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
                            style: {
                                ...cssLabel,
                                lineHeight: Scale.Hpx(20),
                                textAlign: "center",
                                color: "white",
                                position: "relative",
                                top: Scale.Ypx(10),
                            }
                        });

                        let butMaxBetLinear = CreateElement("div", {
                            classes: ["linear"],
                            parentToAppend: this.butMaxBet,
                            style: {
                                ...cssLinear,
                                top: Scale.Ypx(12),
                            }
                        });

                
                    this.butAutoplay = CreateElement("div", 
                        {
                            classes: ["but-auto-play", "button"],
                            parentToAppend: grpAutoplayMaxbet,
                            style: {
                                //flexGrow: "1",
                                alignSelf: "flex-end",
                                ...cssButton,
                                //display: "none",
                                width : Scale.Wpx(122),
                                
                            }
                        });
    
                    let butAutplayLabel = CreateElement("div", 
                            {
                                classes: ["but-auto-play-label", "label"],
                                parentToAppend: this.butAutoplay,
                                childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                                style: {
                                    ...cssLabel,
                                    //fontSize: Scale.fhpx(18),
                                    lineHeight: Scale.Hpx(20),
                                    textAlign: "center",
                                    color: "white",
                                    position: "relative",
                                    top: Scale.Ypx(10),
                                    
                                    
                                }
                            });

                    let butAutoLinear = CreateElement("div", {
                                classes: ["linear"],
                                parentToAppend: this.butAutoplay,
                                style: {
                                    ...cssLinear,
                                    textAlign: "center",   
                                    top: Scale.Ypx(12),
                                }
                            });
    

              
        
        // +
        // `<div class="but-vertical-group but-group-help-games">
        //     <div class="but-help button">
        //         <div class="help-background">
        //             <div class="but-help-icon label">INFO</div>
        //         </div>
        //     </div>
        
        
        //     <div class="but-games button">
        //         <span class="but-games-icon label">MENU</span>
        //     </div>
        // </div>
        // `
        ;
        {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
                this.butVolume = CreateElement("div", {
                    classes: ["but-vol", "button"],
                    parentToAppend: rightCol,
                    style: {
                        ...cssLeftRightButton,
                        ...cssButton,
                        //borderRadius: Scale.XYpx(50),
        
                    }
                });

                    let butVolLabel = CreateElement("div", {
                        classes: ["but-vol-value", "label"],
                        parentToAppend: this.butVolume,
                        style: {
                            ...cssLabel
                        }
                    });
        }

        {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
                this.butHelp = CreateElement("div", {
                    classes: ["but-help", "button"],
                    parentToAppend: rightCol,
                    style: {
                        ...cssButton,
                        ...cssMenuInfoButton,
                    }
                });

                    let butHelpBack = CreateElement("div", {
                        classes: ["help-background"],
                        parentToAppend: this.butHelp
                    });

                        let butHelpLabel = CreateElement("div", {
                            classes: ["but-help-icon", "label"],
                            parentToAppend: butHelpBack,
                            innerHTML: "INFO",
                            style: {
                                ...cssLabel
                            }
                        });
                
                this.butMenu = CreateElement("div", {
                    classes: ["but-games", "button"],
                    parentToAppend: rightCol,
                    style: {
                        
                        ...cssButton,
                        ...cssMenuInfoButton,
                        overflow: "hidden",
                        display:"block",
                        //flexGrow : "0"
                    }
                });
                    // let butMenuLabel = CreateElement("div", {
                    //     classes: ["but-games-icon", "label"],
                    //     parentToAppend: this.butMenu,
                    //     childToAppend: this.translator.Anchor(() => this.translator.t.menu),
                    //     style: {
                    //         ...cssLabel
                    //     }
                    // });
                        this.butSpin = CreateElement("div", {
                        classes: ["but-spin", "button"],
                        parentToAppend: this.view,
                        style: {
                            
                            width: Scale.Wpx(300),
                            alignSelf: "flex-end",
                            position: "relative",
                            height: Scale.Hpx(300),
                            borderRadius: "50%",
                            aspectRatio: "1/1",
                            justifyContent:"center",
                            alignItems: "center",
                            display:"flex",
                            transform: "rotate(90deg)",
                        }
                    });
                    this.spinCircleSmallArrowDiv = CreateElement("div",{
                        classes:["but-spin-arrow", "arrow"],
                        parentToAppend: this.butSpin,
                        style:{
                            height: '40%',
                            width: '40%',                             
                            position: "relative",
                            placeContent: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            borderRadius:"100%",
                        }
                    });
                    /*
                        // <div class="but-turbo-label">Hold for turbo</div>
                        this.turboElem = CreateElement("div", {
                            classes: ["but-turbo-label"],
                            parentToAppend: this.butSpin,
                            innerHTML: "Hold for turbo",
                            style: {
                                //position: "absolute",
                                top: Scale.Ypx(10),
                                width: "100%",
                                fontSize: Scale.fhpx(12),
                                color: "white",
                                textAlign: "center",
                                textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
                            }
                        });*/
                        /*
                        this.spinElem = CreateElement("div", {
                            classes: ["but-spin-label", "label"],
                            parentToAppend: this.butSpin,
                            style: {
                                ...cssLabel,
                                fontSize: Scale.fhpx(40),
                                lineHeight: Scale.Hpx(100)
                            }
                        });*/

                        this.spinArrowDiv = CreateElement("div",{
                            classes:["but-spin-arrow", "arrow"],
                            parentToAppend: this.butSpin,
                            style:{
                                backgroundImage: this.spinArrow.CssBackground(),
                                height: '100%',
                                width: '100%',                            
                                position: "absolute",
                                placeContent: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                            }
                        });
                        // New Element

                        /*let btnSpinLinear = CreateElement("div", {classes: ["linear"], parentToAppend: this.butSpin, style: {
                            ...cssLinear
                        }});*/
        }
    }
    protected override AnimateButtonPress(buttonState: ButtonState, pressed: boolean): void{
        if(pressed){
            if(buttonState.button == Button.ButtonSpin){
                TweenLite.fromTo(this.spinArrowDiv, 1, {rotation:0},{rotation:730});
                this.spinCircleSmallArrowDiv.style.backgroundColor="#FF0000";
            }
        }
    }
    protected override IdleAnim(){
        this.spinCircleSmallArrowDiv.style.backgroundColor="#00CC00";
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        super.PrepareResources(resourceManager);
        //Language View
        await this.languageView.PrepareResources(resourceManager);
        resourceManager.Add(new ImageResource(this.gamePath + "arrow.png", this.resid.ScopedResourceName(["arrow", "cycle"])));//New Element
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.spinArrow = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["arrow", "cycle"]));//New Element

		this.view = CreateElement("div", {
            classes: ["panel", this.resid.Scope()],
            style: {
                position: "absolute",
                bottom: "0px",
                boxSizing: "border-box",
                
                width: "100%",
                height: Scale.Hpx(160),
            
                fontFamily: "NotoSansDisplay-Bold",
                fontWeight: "bold",
            
                display: "flex",
                justifyContent: "space-evenly",
                alignContent: "space-around",

                transformOrigin: "bottom",
		        zIndex: ZIndex.Panel.toString(),
            }
        });
        
        //this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
        this.ConstructHtml();

        this.ConstructButton(Button.ButtonSpin, this.butSpin);
        this.ConstructButton(Button.ButtonCreditsMoney, this.btnBalance);

		//quit this accion button 
		//this.ConstructButton(Button.ButtonLines, this.view.querySelector(".but-lines"));
		this.ConstructButton(Button.ButtonBetNext, this.butTotalBet);
		//quit this accion button 
		//this.ConstructButton(Button.ButtonCollect, this.view.querySelector(".but-collect"));
		//quit this accion button 
		//this.ConstructButton(Button.ButtonDenom, this.view.querySelector(".but-select-denom"));
		this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
        //(this.ConstructButton(Button.ButtonGamesMenu, this.butMenu, 500);
		this.ConstructButton(Button.ButtonVolumeNext, this.butVolume);
		//quit this accion button 
		//this.ConstructButton(Button.ButtonCredit, this.view.querySelector(".but-credit"));
		this.ConstructButton(Button.ButtonAutoplay, this.butAutoplay);
		this.ConstructButton(Button.ButtonMaxBet, this.butMaxBet);
		this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);


		// this.panelElements.push(this.butTotalBet);
		// this.panelElements.push(this.butHelp);
		// this.panelElements.push(this.butMenu);
		// this.panelElements.push(this.butVolume);
		// this.panelElements.push(this.butDenom);
		// this.panelElements.push(this.view.querySelector(".but-totalbet"));
		// this.panelElements.push(this.view.querySelector(".but-win"));
		// this.panelElements.push(this.view.querySelector(".but-credit"));
		// this.panelElements.push(this.butMaxBet);
		// this.panelElements.push(this.butSpin);
		
		//let btnColor = this.ButtonBackground();
		
		// let linearElement= this.view.querySelectorAll(".linear");
		// SetStyles(linearElement,{
		// 	borderImage: btnColor.linearColor,
		// })
		
		// SetStyles(this.panelElements,{
		// 	backgroundImage:btnColor.backgroundButtonColor,
		// })

		// this.balanceCredits = this.view.querySelector(".but-credit-credit")
        // this.balanceCurrency = this.view.querySelector(".but-credit-currency")

		//this.winCredits = this.view.querySelector(".but-win-credit")
		//this.winCurrency = this.view.querySelector(".but-win-currency")

		// this.betCredits = this.view.querySelector(".but-betperline-credit")
		// this.betCurrency = this.view.querySelector(".but-betperline-currency")

		// this.totalBetCredits = this.view.querySelector(".but-totalbet-credit")
		// this.totalBetCurrency = this.view.querySelector(".but-totalbet-currency")

		// this.balanceCredits = this.view.querySelector(".but-credit-credit")
		// this.balanceCurrency = this.view.querySelector(".but-credit-currency")

		//this.denomElem = this.view.querySelector(".denom-denom")
		//this.linesElem = this.view.querySelector(".selected-lines")
		//this.spinElem = this.view.querySelector(".but-spin-label")

		//this.turboElem = this.view.querySelector(".but-turbo-label")
/*
		if (!this.backendSettings.GetBool("play.turbo"))
		{
			this.turboElem.style.display = "none";
		}*/

		this.volume0 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume0", "image"]));
		this.volume1 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume1", "image"]));
		this.volume2 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume2", "image"]));
		this.volume3 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume3", "image"]));
		
		
		//this.view.querySelector(".but-spin-label").innerHTML = "SPIN";
		this.audio.OnVolumeChange((volumeLevel :number, volumeFactor: number)=> this.OnVolumeChange(volumeLevel,volumeFactor));


		//this.turboAnim.Start();
	
         //language flag
		await this.languageView.ResourcesLoaded(resourceManager);
        // let laguangeView = this.languageView.View();
        // laguangeView.style.position = "relative";
        // laguangeView.style.right =  Scale.Xpx(9);
        // laguangeView.style.width = Scale.Wpx(87);
        // laguangeView.style.height = Scale.Hpx(71);
        // laguangeView.style.top = Scale.Ypx(-7);
        // laguangeView.style.backgroundSize = "cover";

		this.butMenu.appendChild(this.languageView.View());

        this.AutoPlayLoaded();
    }


    protected override AutoPlayPrepare(): void
    {
    }

    protected override AutoPlayLoaded()
    {
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem)
        {
            this.autoPlayTimer = this.systemContext.TimingContext().CreateInterval("autoplay", 250, () => {
                if (this.autoPlayColor == "red")
                {
                    this.autoPlayColor = "transparent";
                    SetStyles(autoPlayButtonElem, this.buttonBorder);
                }
                else
                {
                    this.autoPlayColor = "red";
                    SetStyles(autoPlayButtonElem, this.autoplayButtonBorder);
                }
            });
        }
    }

    public override AutoplayEnable(): void
    {
        this.autoPlayTimer?.Start();
    }

    public override AutoplayDisable(): void
    {
        this.autoPlayTimer?.Stop();
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem)
        {
            SetStyles(autoPlayButtonElem, this.buttonBorder);
            //autoPlayButtonElem.style.borderColor = "transparent"
        }

    }
    public override SpinButtonLabelChange(state: string): void{}
    protected override IdleAnimStop()
	{

		this.idleAnim.Stop();


		// off
		this.idleAnimState = false;
		this.butElem.get(Button.ButtonSpin).style.boxShadow= "none";
		//this.butElem.get(PanelButton.Spin).style.backgroundColor= "transparent";

		//this.turboAnimState = false;
	}
}
